import type { Schema } from '@/types/mercury-data-types/unifiedapi';

export type SupportRfiRequestPayload = Partial<Schema<'RfiCreateRequest'>> &
  Pick<Schema<'RfiCreateRequest'>, 'name' | 'description' | 'due_at'>;

export const buildSupportRfiFormData = (
  request: SupportRfiRequestPayload,
  attachments?: File[]
): FormData => {
  const formData = new FormData();

  formData.append('request', JSON.stringify(request));

  attachments?.forEach((attachment) => {
    formData.append('file', attachment);
  });

  return formData;
};
